/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { Locale } from '../../../../core/locale/Locale';
import { LocaleKeys } from '../../../../core/locale/LocaleKeys';
import { ActionItemProps } from './ActionItemProps';

import './ActionItem.scss';

const ActionItem: FunctionComponent<ActionItemProps> = (props): JSX.Element => {
    const { name, highlighted } = props;
    return (
        <div className={`${highlighted ? 'highlighted-action-item' : 'action-item'}`}>
            {name === Locale.getString(LocaleKeys.LIVE_TV_ACTION_STRIP_RESUME) ? (
                <div className="action-icon-resume" data-testid="action-item-resume"></div>
            ) : null}
            <div data-testid={`action-item-${name}`}>{name}</div>
        </div>
    );
};

ActionItem.propTypes = {
    name: PropTypes.string.isRequired,
    highlighted: PropTypes.bool.isRequired,
};

export default ActionItem;
